import(/* webpackMode: "eager", webpackExports: ["Service"] */ "/app/next/src/components/pages/Service/Service.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
